import {
  Box,
  List,
  Drawer,
  Hidden,
  Button,
  Dialog,
  Typography,
  ListSubheader,
  DialogActions,
  DialogContent,
  IconButton,
} from "@mui/material";
import NavItem from "./components/NavItem";
import { ACROSS_LOGO } from "../../../assets";
import PerfectScrollbar from "react-perfect-scrollbar";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { ExitToApp as ExitToAppIcon } from "@mui/icons-material";
import GlobalExpandNavItem from "../../../components/GlobalExpandNavItem";
import { useNavbarData } from "./NavbarData";
import "./index.scss";

const VENDOR_SECTION = [
  {
    items: [
      {
        title: "Dashboard",
        icon: DashboardIcon,
        href: "/admin-dashboard",
      },
    ],
  },
];

function renderNavItems({ items, pathname, depth, isCollapsed }) {
  return (
    <List disablePadding>
      {items?.map((item, index) =>
        item?.isAccordion ? (
          <GlobalExpandNavItem
            key={index}
            item={item}
            isCollapsed={isCollapsed}
          />
        ) : (
          <NavItem
            key={index}
            href={item?.href}
            icon={item?.icon}
            title={item?.title}
            isCollapsed={isCollapsed}
          />
        )
      )}
    </List>
  );
}

const NavBar = ({
  onMobileClose,
  openMobile,
  isSidebarOpen,
  toggleSidebar,
}) => {
  const { location, navigate, isLogout, setIsLogout, onLogout, Transition } =
    useNavbarData({ onMobileClose, openMobile });

  const content = (
    <Box
      className={`dashboard-navbar ${
        isSidebarOpen
          ? "dashboard-navbar--expanded"
          : "dashboard-navbar--collapsed"
      }`}
    >
      <Box className="dashboard-navbar__logo">
        <IconButton
          onClick={() => navigate("/admin-dashboard")}
          className="dashboard-navbar__logo-button"
        >
          {isSidebarOpen ? (
            <img
              alt="Logo"
              src={ACROSS_LOGO}
              className="dashboard-navbar__logo-img"
            />
          ) : (
            <Typography className="dashboard-navbar__logo-text">A</Typography>
          )}
        </IconButton>
        <IconButton
          onClick={toggleSidebar}
          className="dashboard-navbar__toggle-button"
        >
          {isSidebarOpen ? "◀" : "▶"}
        </IconButton>
      </Box>

      <PerfectScrollbar
        options={{ suppressScrollX: true }}
        className="dashboard-navbar__scroll"
      >
        <Box className="dashboard-navbar__menu">
          <Box className="dashboard-navbar__menu-box">
            {VENDOR_SECTION?.map((section, i) => (
              <List
                key={`menu${i}`}
                subheader={
                  <ListSubheader disableGutters disableSticky>
                    {section.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  items: section.items,
                  pathname: location?.pathname,
                  isCollapsed: !isSidebarOpen,
                })}
              </List>
            ))}
          </Box>
        </Box>

        <Box className="dashboard-navbar__logout-container">
          <Button
            onClick={() => setIsLogout(true)}
            className="dashboard-navbar__logout-button"
          >
            <ExitToAppIcon className="dashboard-navbar__logout-icon" />
            {isSidebarOpen && (
              <Typography
                variant="body"
                className="dashboard-navbar__logout-text"
              >
                Logout
              </Typography>
            )}
          </Button>
        </Box>

        {isLogout && (
          <Dialog
            fullWidth
            maxWidth="xs"
            open={isLogout}
            TransitionComponent={Transition}
            onClose={(event, reason) => {
              if (reason === "backdropClick" || reason === "escapeKeyDown") {
                return;
              }
              setIsLogout(false);
            }}
            BackdropProps={{
              style: { pointerEvents: "none" },
            }}
            className="dashboard-navbar__dialog"
          >
            <Box className="dashboard-navbar__dialog-content">
              <DialogContent>
                <Box className="dashboard-navbar__dialog-title">
                  <Typography
                    variant="h6"
                    className="dashboard-navbar__dialog-heading"
                  >
                    Logout
                  </Typography>
                  <Typography
                    variant="body2"
                    className="dashboard-navbar__dialog-text"
                  >
                    Are you sure you want to logout?
                  </Typography>
                </Box>
              </DialogContent>
              <DialogActions className="dashboard-navbar__dialog-actions">
                <Button
                  type="submit"
                  variant="contained"
                  className="dashboard-navbar__dialog-button dashboard-navbar__dialog-button--confirm"
                  onClick={() => onLogout()}
                >
                  Confirm
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  className="dashboard-navbar__dialog-button dashboard-navbar__dialog-button--cancel"
                  onClick={() => setIsLogout(false)}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Box>
          </Dialog>
        )}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={openMobile}
          variant="temporary"
          onClose={onMobileClose}
          className="dashboard-navbar__drawer dashboard-navbar__drawer--mobile"
        >
          {content}
        </Drawer>
      </Hidden>

      <Hidden lgDown>
        <Drawer
          open
          anchor="left"
          variant="persistent"
          className="dashboard-navbar__drawer dashboard-navbar__drawer--desktop"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

export default NavBar;
